"use client";
import Link from "next/link";
import { TypeAnimation } from "react-type-animation";

export default function LeftSideContent({ data }) {
  const generateSequence = (roles) => {
    const sequence = [];
    roles.forEach((role, index) => {
      sequence.push(index === 0 ? 500 : 1000);
      sequence.push(role);
    });
    sequence.push(1500);

    return sequence;
  };

  const sequence = generateSequence(data?.roles);

  return (
    <div className="md:w-1/2">
      <h4 className="sm:text-2xl xs:text-md">
        Hello, My name is{" "}
        <span className="text-rose-400 sm:text-2xl xs:text-xl font-semibold font-serif">
          {data?.name}
        </span>
      </h4>

      <div className="text-base md:text-xl lg:text-3xl text-white my-5">
        <TypeAnimation
          preRenderFirstString={true}
          sequence={sequence}
          speed={50}
          repeat={Infinity}
        />
      </div>

      <p className="mt-4 sm:text-lg xs:text-md capitalize dark:text-gray-200">
        {/* {`I'm`} a passionate Full-Stack Developer with a knack for creating
            dynamic and responsive web applications. I love turning ideas into
            reality using code. */}
        {data?.bio}
      </p>

      <div
        className="flex flex-wrap gap-4 mt-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
      >
        <Link href="/contact">
          <button
            className="py-4 px-6 text-sm rounded-full bg-gradient-to-tr from-rose-600 via-rose-500 to-rose-400 shadow-lg shadow-rose-500/50 text-white cursor-pointer font-semibold text-center"
            // whileHover={{
            //   scale: 1.05,
            //   background: "linear-gradient(to left, #e11d48, #f43f5e, #fb7185)",
            //   transition: { duration: 0.3 },
            // }}
            whileTap={{ scale: 0.95 }}
          >
            HIRE ME
          </button>
        </Link>

        <a href={data?.cvLink}>
          <button
            className="py-4 px-6 text-sm rounded-full bg-gradient-to-tr from-rose-600 via-rose-500 to-rose-400 shadow-lg shadow-rose-500/50 text-white cursor-pointer font-semibold text-center"
            // whileHover={{
            //   scale: 1.05,
            //   background: "linear-gradient(to left, #e11d48, #f43f5e, #fb7185)",
            //   transition: { duration: 0.3 },
            // }}
            whileTap={{ scale: 0.95 }}
          >
            DOWNLOAD CV
          </button>
        </a>
      </div>
    </div>
  );
}
